import Script from 'react-load-script';
import { useSelector } from 'react-redux';
import { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';

const googleUrl = 'https://www.google.com/recaptcha/api.js?render=explicit';
const txUrl = 'https://turing.captcha.qcloud.com/TCaptcha.js';

const FJCaptcha = (props, ref) => {
    const { countryCode } = useSelector(state => {
        return {
            countryCode: state.mainStore.countryCode,
        };
    });

    const [captchaUrl, setCaptchaUrl] = useState(googleUrl);
    const isLoaded = useRef(false);

    useImperativeHandle(ref, () => ({
        loadApi: () => {
            if (!isLoaded.current) {
                setCaptchaUrl('');
                setTimeout(() => {
                    if (countryCode === 'CN') {
                        setCaptchaUrl(txUrl + '?v=' + new Date().getTime());
                    } else {
                        setCaptchaUrl(googleUrl + '&v=' + new Date().getTime());
                    }
                }, 100);
            }
        },
    }));

    useEffect(() => {
        if (countryCode === 'CN') {
            setCaptchaUrl(txUrl);
        } else {
            setCaptchaUrl(googleUrl);
        }
    }, [countryCode]);

    // 腾讯or谷歌三方验证sdk加载失败
    const handleScriptError = () => {
        console.log('err Google Or Tencent');
        isLoaded.current = false;
    };

    const handleScriptLoad = () => {
        isLoaded.current = true;
    };

    return (
        <div>
            {captchaUrl ? <Script url={captchaUrl} onError={handleScriptError} onLoad={handleScriptLoad} /> : null}
        </div>
    );
};
export default forwardRef(FJCaptcha);
